import React from 'react';

import MarkerIcon from '../../../assets/marker-icon';
import UsersIcon from '../../../assets/users-icon';
import LabelIcon from '../../../components/label-icon';

const TOTAL_FACILITIES_DISPLAYED = 3;

const Facility = ({ label }) => (
  <div className="inline-flex">
    <span className="text-gray-800 text-xs font-medium mr-2 px-1 py-0.5 rounded border border-gray-200">
      {label}
    </span>
  </div>
);

const Card = ({ name, sourceImage, onClick, location, capacity, facilities }) => {
  return (
    <div
      className="w-full bg-white border border-gray-200 rounded-lg hover:cursor-pointer"
      onClick={onClick}
    >
      <img className={`rounded-lg h-[210px] w-full object-cover`} src={sourceImage} alt={name} />
      <div className="px-5 py-5 text-left">
        <h5 className="mb-4 text-xl font-semibold tracking-tight text-gray-900">{name}</h5>
        <div className="mb-2">
          <LabelIcon
            label={location}
            icon={<MarkerIcon />}
            className="flex text-base items-center gap-4"
          />
        </div>
        <div className="mb-2">
          <LabelIcon
            label={`${capacity} Orang`}
            icon={<UsersIcon />}
            className="flex text-base items-center gap-4"
          />
        </div>
        {facilities?.length > 0 && (
          <div className="w-full mb-2 space-y-2">
            {facilities?.slice(0, TOTAL_FACILITIES_DISPLAYED).map((facility) => (
              <Facility label={facility?.name?.toUpperCase?.()} key={facility?.name} />
            ))}
            {facilities?.length > TOTAL_FACILITIES_DISPLAYED && (
              <Facility label={`${facilities?.length - 3}+`} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
